import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useBooking } from '../context/BookingContext';
import { LOGO_URL } from '../config/site';
import './Navbar.css';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();
  const { openCalendly } = useBooking();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      <div className="container">
        <div className="navbar-content">
          <div className="navbar-logo">
            <Link to="/" className="logo-link">
              <img
                src={LOGO_URL}
                alt="Cure8 Studios Logo"
                className="logo-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="logo-fallback">
                <span className="logo-text">Cure8 Studios</span>
              </div>
            </Link>
          </div>

          <div className={`navbar-menu ${isMenuOpen ? 'navbar-menu-open' : ''}`}>
            {location.pathname === '/' ? (
              <>
                <a
                  href="/#how-it-works"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('how-it-works');
                  }}
                  className="navbar-link"
                >
                  The Method
                </a>
                <a
                  href="/#pricing"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('pricing');
                  }}
                  className="navbar-link"
                >
                  Packages
                </a>
                <a
                  href="/#why-cure8"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('why-cure8');
                  }}
                  className="navbar-link"
                >
                  Why Cure8
                </a>
                <a
                  href="/#diagnosis"
                  onClick={(e) => {
                    e.preventDefault();
                    scrollToSection('diagnosis');
                  }}
                  className="navbar-link"
                >
                  Free check
                </a>
              </>
            ) : (
              <Link to="/" className="navbar-link">Back to Home</Link>
            )}
          </div>

          <div className="navbar-actions">
            <button
              type="button"
              className="btn navbar-cta"
              onClick={() => {
                openCalendly();
                setIsMenuOpen(false);
              }}
            >
              Book an Assessment
            </button>

            <button
              className="navbar-toggle"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
